import api from './api'

export const pinsApi = {
  // List PINs (Teacher/Admin)
  async listPins() {
    try {
      const response = await api.get('/pins')
      return {
        success: true,
        data: response.data || response
      }
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Error loading PINs',
        error
      }
    }
  },

  // Create PIN
  async createPin(pinData) {
    try {
      const response = await api.post('/pins', pinData)
      return {
        success: true,
        data: response.data || response
      }
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Error creating PIN',
        error
      }
    }
  },

  // Validate PIN (Student)
  async validatePin(code) {
    try {
      const response = await api.get(`/pins/${code}`)
      return {
        success: true,
        data: response.data || response
      }
    } catch (error) {
      return {
        success: false,
        message: error.message || 'PIN validation error',
        error
      }
    }
  },

  // Student Access with PIN
  async accessWithPin(code) {
    try {
      const response = await api.post(`/pins/${code}/access`)
      return {
        success: true,
        data: response.data || response
      }
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Access error',
        error
      }
    }
  },

  // Delete PIN (Teacher/Admin)
  async deletePin(pinId) {
    try {
      const response = await api.delete(`/pins/${pinId}`)
      return {
        success: true,
        data: response.data || response
      }
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Error deleting PIN',
        error
      }
    }
  }
}